module.exports = __webpack_public_path__ + "5ecc5c5289a80dd03b8d955ff2871613.png";


//////////////////
// WEBPACK FOOTER
// ../lib/assets/shared/difficulty_4.png
// module id = 163
// module chunks = 0